export interface Page<T> extends Record<any, any> {
    /**
     * 分页数量
     */
    length: number

    /**
     * 当前页数
     */
    page: number

    /**
     * 总数量，要求请求参数countTotal为1才有值。
     * 在page为1的情况下重新生成，非1的情况下客户端有上传total，则返回客户端上传的total。
     */
    total?: number | string

    /**
     * 返回的数据列表
     */
    list?: T[] | null

    /**
     * 时间戳
     */
    timestamp?: number | string | null
}


export interface PageRequest extends Record<any, any> {
    /**
     * 分页数量
     */
    length?: number

    /**
     * 当前页数
     */
    page?: number

    /**
     * 总数量，要求请求参数countTotal为1才有值。
     * 在page为1的情况下重新生成，非1的情况下客户端有上传total，则返回客户端上传的total。
     */
    total?: number | string
}

export function EmptyPage<T>(): Page<T> {
    return {
        length: 0, list: [], page: 0
    }
}